export interface InteractionState {
  wishlisted: boolean
  visited: boolean
  wishlisted_at: string | null
  visited_at: string | null
}

function csrfToken(): string {
  const el = document.querySelector('meta[name="csrf-token"]')
  return el?.getAttribute('content') || ''
}

async function call(method: 'POST' | 'DELETE', url: string): Promise<InteractionState | null> {
  try {
    const res = await fetch(url, {
      method,
      headers: { 'X-CSRF-Token': csrfToken(), Accept: 'application/json' },
      credentials: 'same-origin',
    })
    if (!res.ok) return null
    const data = await res.json()
    return {
      wishlisted: !!data.wishlisted,
      visited: !!data.visited,
      wishlisted_at: data.wishlisted_at ?? null,
      visited_at: data.visited_at ?? null,
    }
  } catch {
    return null
  }
}

export function toggleWishlist(locationId: number, on: boolean) {
  return call(on ? 'POST' : 'DELETE', `/api/v1/locations/${locationId}/wishlist`)
}

export function toggleVisit(locationId: number, on: boolean) {
  return call(on ? 'POST' : 'DELETE', `/api/v1/locations/${locationId}/visit`)
}
